import React from 'react'
import StillImage from './StillImage'

function BackgroundSideNav() {
  return (
    <div style={{ flex: '1 1 280px ' }}>
       <div className="p-1 ">
      {/* Heading Section */}
      <div className="font-bold text-lg py-2 px-1">
        Background
      </div>

      {/* Title Field */}
    

     <StillImage/>
    </div>
    </div>
  )
}

export default BackgroundSideNav